<template>
<div>
  <b-card>
    <b-nav pills class="mb-2">
      <b-nav-item class="btn-pill" href="#/settings/user/contractors" :active="linkActive('contractors')"> Contractor</b-nav-item>
      <b-nav-item class="btn-pill" href="#/settings/user/admin" :active="linkActive('admin')">Administrator</b-nav-item>
    </b-nav>
    <hr class="mb-4" />
    <router-view></router-view>
  </b-card>
</div>
</template>

<script>
export default {
  methods: {
    linkActive (name) {
      return this.$route.path.indexOf(name) > -1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/settings/User.vue